<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'paymentApplyDetail',
    components: {
      baseEdit,
    },
  };
</script>
